import { render, staticRenderFns } from "./_event.vue?vue&type=template&id=5342e272&"
import script from "./_event.vue?vue&type=script&lang=ts&"
export * from "./_event.vue?vue&type=script&lang=ts&"
import style0 from "./_event.vue?vue&type=style&index=0&id=5342e272&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShipSteps: require('C:/inetpub/wwwroot/bike-flights/components/ship/ShipSteps.vue').default,LoaderSpinner: require('C:/inetpub/wwwroot/bike-flights/components/LoaderSpinner.vue').default})
